import { Get, Post, Put, Delete } from "utils/api.utils";
import ApiPath from "enums/api-path";

export const getMovements = async (query) => {
  const res = await Get(`${ApiPath.PriceMovement}`, { ...query });
  return { movements: res.data || [], count: res.count ?? 0 };
};

export const getMovement = async ({ movementId }) => {
  const res = await Get(`${ApiPath.PriceMovement}/${movementId}`);
  return res.data;
};

export const createMovement = async (body) => {
  const res = await Post(`${ApiPath.PriceMovement}`, body);
  return res.data;
};

export const updateMovement = async ({ movementId, ...body }) => {
  const res = await Put(`${ApiPath.PriceMovement}/${movementId}`, body);
  return res.data;
};

export const deleteMovement = async ({ movementId }) => {
  const res = await Delete(`${ApiPath.PriceMovement}/${movementId}`);
  return res.data;
};
